import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    height: '100%',
  },
  backButton: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginBottom: 4,
    flexDirection: 'row',
    gap: 15,
    alignItems: 'center',
    borderWidth: 2,
    borderColor: 'transparent',
  },
  backButtonFocus: {
    borderColor: FOCUS_COLOR,
  },
  backButtonInner: {
    flexDirection: 'row',
    gap: 15,
    alignItems: 'center',
    flex: 1,
  },
  backButtontext: {
    fontSize: 16,
    lineHeight: 20,
    height: 20,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  backButtonIcon: { width: 16, height: 14, color: brand.main.water },
});
